import { z } from 'zod';
import { CursorQuery, Paginated } from '../../common/pagination.js';
import { ChatMessage, SendMessageInput, ThreadView } from '../../chat.js';
export const chatRoutes = {
    threads: {
        method: 'GET',
        path: '/me/threads',
        query: CursorQuery,
        response: Paginated(ThreadView),
    },
    /** Open (or create) the thread with a connection — the "Chat Now" tap. */
    openWith: { method: 'POST', path: '/users/:userId/thread', response: ThreadView },
    messages: {
        method: 'GET',
        path: '/threads/:threadId/messages',
        query: CursorQuery,
        response: Paginated(ChatMessage),
    },
    send: {
        method: 'POST',
        path: '/threads/:threadId/messages',
        body: SendMessageInput,
        response: ChatMessage,
    },
    markRead: {
        method: 'POST',
        path: '/threads/:threadId/read',
        response: z.object({ threadId: z.string(), unreadCount: z.number().int() }),
    },
};
//# sourceMappingURL=routes.js.map